import React from 'react';
import styled from 'styled-components';

export const RequiredMark: React.FC = () => {
  return <Wrapper>*</Wrapper>;
};

const Wrapper = styled.span`
  margin-left: 0.25em;
  color: #9f3a38;
  font-size: 1em;
  vertical-align: top;
`;
